import { IBaseViewExtensionViewFactoryConstructorParameter } from '#/CoreFrameInterfaces';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import ViewViewModel from '@/ViewModels/ViewViewModel';
import View from '@/Views/View';

export default class BaseViewExtensionViewFactory extends ViewFactory {
    public viewModel: ViewViewModel;
    public view: View;

    protected ViewModel: typeof ViewViewModel;
    protected View: typeof View;
    protected viewElementName: string;

    constructor(protected params: IBaseViewExtensionViewFactoryConstructorParameter) {
        super(params);

        this.ViewModel = ComponentManager.getViewModel<typeof ViewViewModel>(params.viewModelName);
        this.View = ComponentManager.getView<typeof View>(params.viewName);
        this.viewElementName = this.paramOrDefault(params.viewElementName);
    }

    public getRegion(): string {
        return 'Content';
    }

    public getView(): any {
        this.resolveDependencies(['Wireframe']);

        if (this.viewModel == null) {
            this.viewModel = new this.ViewModel($.extend({ viewFactory: this }, this.params));
        }

        if (this.view == null) {
            // Der View-Konstruktor nimmt eigentlich keine Parameter entgegen, nach Konvention tun dies aber alle erbenden Komponenten
            const viewConstructor = this.View as any;
            this.view = new viewConstructor(this.viewModel, this.createRootElement(this.viewElementName));
        }

        this.setPageTitle(ResourceManager.getInstance().get(this.ergName));
        let tuple = this.view.getTuple();
        return tuple.view;
    }

    public refresh(): any {
        // Unterklassen müssen sich selbst um ihre Aktualsierung kümmern, hier gibt es keinen Standard
        return false;
    }
}

// dient nur als "oberklasse"